var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrollToTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.967 28C7.27249 28 7.57173 27.8753 7.78993 27.6571C8.00814 27.4389 8.13282 27.1459 8.13282 26.8342L8.13283 4.04145L11.9607 7.87557C12.2537 8.16235 12.6777 8.26833 13.0767 8.16235C13.4756 8.05636 13.7811 7.74465 13.8934 7.34565C13.9993 6.94665 13.8934 6.52272 13.6066 6.2297L7.78994 0.413068C7.57174 0.194867 7.27249 0.0701803 6.96701 0.0701803C6.65529 0.0701803 6.36227 0.194866 6.14407 0.413068L0.327438 6.2297C0.040659 6.52272 -0.0653248 6.94665 0.0406588 7.34565C0.146643 7.74465 0.458359 8.05013 0.857357 8.16235C1.25635 8.26833 1.68029 8.16235 1.9733 7.87557L5.80742 4.04145L5.80742 26.8404C5.80742 27.1459 5.9321 27.4451 6.1503 27.6633C6.36851 27.8815 6.65529 28 6.967 28Z",
    fill: "url(#paint0_linear_1758_1037)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1758_1037",
    x1: 3.23172,
    y1: 41.5396,
    x2: -3.26072,
    y2: -20.5079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204916,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F3F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2F2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scroll-to-top.22dc91e2812575cb2839d90d65059f78.svg";
export { ForwardRef as ReactComponent };